import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiLoader } from "react-icons/fi";
import NexaLogo from "../components/NexaLogo";
import { api } from "../services/api";
import { saveSession } from "../utils/auth";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [submittedOnce, setSubmittedOnce] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

  const validateForm = () => {
    const newErrors = {};
    if (!name.trim() || name.trim().length < 2) newErrors.name = "Name must be at least 2 characters";
    if (!email.trim() || !validateEmail(email)) newErrors.email = "Please enter a valid email address";
    if (!password.trim() || password.length < 8) newErrors.password = "Password must be at least 8 characters";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmittedOnce(true);
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) return setErrors(newErrors);

    setErrors({});
    setLoading(true);
    try {
      const data = await api.post("/auth/register", { name, email, password });
      saveSession(data);
      navigate("/chatbot");
    } catch (err) {
      setErrors({ general: err.message || "Registration failed. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    if (field === "name") setName(value);
    if (field === "email") setEmail(value);
    if (field === "password") setPassword(value);
    if (submittedOnce) setErrors(validateForm());
  };

  return (
    <div className="h-screen flex justify-center items-center bg-gray-100">
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-md w-96">
        <div className="flex items-center gap-2 justify-center mb-6">
          <NexaLogo size={32} />
          <span className="font-bold text-gray-900 text-lg tracking-tight">NexaGPT</span>
        </div>

        <h2 className="text-xl font-semibold mb-6 text-center text-gray-800">Create your account</h2>

        <input
          type="text"
          placeholder="Full name"
          value={name}
          onChange={(e) => handleChange("name", e.target.value)}
          className="w-full mb-2 p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
        />
        {errors.name && <p className="text-red-500 text-sm mb-2">{errors.name}</p>}

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => handleChange("email", e.target.value.toLowerCase())}
          className="w-full mb-2 p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
        />
        {errors.email && <p className="text-red-500 text-sm mb-2">{errors.email}</p>}

        <input
          type="password"
          placeholder="Password (min 8 characters)"
          value={password}
          onChange={(e) => handleChange("password", e.target.value)}
          className="w-full mb-2 p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
        />
        {errors.password && <p className="text-red-500 text-sm mb-2">{errors.password}</p>}

        {errors.general && <p className="text-red-500 text-sm mb-2 text-center">{errors.general}</p>}

        <button
          type="submit"
          disabled={loading}
          className={`mt-4 w-full flex items-center justify-center bg-primary text-white px-4 py-2 rounded hover:opacity-90 ${loading ? "cursor-not-allowed opacity-70" : ""}`}
        >
          {loading && <FiLoader className="animate-spin mr-2" size={20} />}
          {loading ? "Creating account..." : "Create Account"}
        </button>

        <p className="mt-4 text-sm text-center text-gray-500">
          Already have an account?{" "}
          <span onClick={() => navigate("/login")} className="text-primary cursor-pointer hover:underline">
            Sign In
          </span>
        </p>
      </form>
    </div>
  );
};

export default Register;
